import { Outlet, useLocation } from 'react-router-dom';


import React, { useState, useEffect } from "react";
import { Loader, Navbar, Footer } from "../../front/frontComponents";
import {
  useCartContext,
  useProductsContext,
  useWishlistContext,
} from "../../front/contexts";


// ==============================|| MINIMAL LAYOUT ||============================== //

const FrontHeader = () => {
  const [loadingData, setLoadingData] = useState(false);
  const { loading } = useProductsContext();
  const { loadingCart } = useCartContext();
  const { loadingWishlist } = useWishlistContext();
  useEffect(() => {
    setLoadingData(true);
    const id = setTimeout(() => {
      setLoadingData(false);
    }, 2000);

    return () => {
      clearTimeout(id);
    };
  }, []);

   return (

   <>
    <div className="min-h-[100vh]">
      <Navbar />
      <div className="main_container_box">
        {loadingData || loading || loadingCart || loadingWishlist ? (
          <Loader />
        ) : (
          <Outlet />
        )}


      </div>
      <Footer />
    </div>
  </>
   )
        
  
  }

export default FrontHeader;
